<template>
  <div class="item columns">
    <div class="column is-5 left-col" @click="saveAndAdvance(saveAndAdvanceIndex)">{{ title }}
      <span class="button is-small is-primary" v-if="allComplete">COMPLETED</span>
    </div>
    <div class="column right-col">
      <span class="row">
        <CircledCheckMarkCircleIcon :checked="videoComplete" class="completed--icon" />
        <p>Video</p>
      </span>
      <span class="row">
        <CircledCheckMarkCircleIcon :checked="commentComplete" class="completed--icon" />
        <p>Comments</p>
      </span>
      <span v-if="isCoaching" class="row">
        <CircledCheckMarkCircleIcon :checked="coachingComplete" class="completed--icon" />
        <p>Coaching Conversation</p>
      </span>
      <span class="row">
        <CircledCheckMarkCircleIcon :checked="reflectionComplete" class="completed--icon" />
        <p>Reflection</p>
      </span>
    </div>
  </div>
</template>

<script>

  import CircledCheckMarkIcon from './CircledCheckMarkIcon.vue'
  import CircledCheckMarkCircleIcon from './CircledCheckMarkCircleIcon.vue'

  export default {
    name: 'ExerciseDropdown',
    components: {
      CircledCheckMarkIcon,
      CircledCheckMarkCircleIcon
    },
    props: {
      title: {
        type: String,
        required: true,
      },
      isCoaching: {
        type: Boolean,
        required: true,
      },
      saveAndAdvance: {
        type: Function,
        requred: true
      },
      saveAndAdvanceIndex: {
        type: Number,
        required: true,
      },
      videoComplete: {
        type: Boolean,
        required: true,
      },
      commentComplete: {
        type: Boolean,
        required: true,
      },
      reflectionComplete: {
        type: Boolean,
        required: true,
      },
      coachingComplete: {
        type: Boolean,
        required: true,
      },
    },
    computed: {
      allComplete () {
        if (this.isCoaching) {
          this.videoComplete && this.commentComplete && this.reflectionComplete && this.coachingComplete
        } else {
          return this.videoComplete && this.commentComplete && this.reflectionComplete
        }
      },
    },
  }
</script>
<style lang="scss" scoped>

svg {
  margin-right: 1rem;
}

.row {
  display: flex;
  align-items: center;
  margin-bottom: 1rem;
}

.drop-down {
  margin-top: 0px !important;
  padding: 0px !important;
  box-shadow: none !important;
  border-top: none !important;
  border-color: #000;
  border-style: solid;
  border-width: 2px;
}

.item {
  margin-left: 0rem !important;
  margin-right: 0rem !important;
  margin-bottom: 0rem !important;
  margin-top: 0rem !important;
  border-left: 2px solid #000;
  border-right: 2px solid #000;
}

.left-col {
  margin-top: 2rem;
  margin-bottom: 2rem;
  cursor: pointer;
}

.right-col {
  border-left: 2px solid #000;
}

.drop-down > div {
  border-bottom: 2px solid #000;
  font-size: 1.5rem;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// ExerciseDropdown.vue?10da9783